import React, { Component } from 'react'
import './HistorialSolicitudes.css'; 
import {getSolicitudesCorrectivos,clearErrors,deleteMtoCorrectivo} from '../../../redux/actions/dataactions';
import {subirEvidenciaSolicitudCorrectivo} from '../../../redux/actions/dataasistencialactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaArrowLeft, FaCheck, FaPlus } from 'react-icons/fa';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  TextField
} from '@mui/material';
import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import PhotoIcon from '@mui/icons-material/Photo';


export class HistorialSolicitudes extends Component {

    constructor(){
        super();
        this.state={
            
            errors:{},
            open:false,
            opendelete:false,
            idsolicitud:'',
            fechasolicitud:'',
            horasolicitud:'',
            numsolicitud:'',
            fallareportada:'',

            aprobado: {},
            selectedFile: null,
            selectedFileUrl: null,          
            accion: null,
            imageUrl: null


          
        };
        
    };

    componentDidMount(){
        this.props.getSolicitudesCorrectivos(this.props.equipoId);
       }

    static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
          newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
          newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }

    handleOpen = (rowdatasolicitudid, rowDataimageUrl , accion) => {
      this.setState({ open: true, solicitudid: rowdatasolicitudid, accion: accion, imageUrl : rowDataimageUrl });
    };
  
    onFileChange = event => {
      // Update the state with the selected file
      this.setState({ selectedFile: event.target.files[0] });
  
      // Create a URL for the selected file and update the state with it
      this.setState({ selectedFileUrl: URL.createObjectURL(event.target.files[0]) });
    };
  
    onFileUpload = (event) => {
      event.preventDefault();
      // Create an object of formData 
      const formData = new FormData();
  
      // Update the formData object 
      formData.append(
        "myFile",
        this.state.selectedFile,
        this.state.selectedFile.name
      );
      //this.props.subirImagenPerfil(formData);
      this.props.subirEvidenciaSolicitudCorrectivo(formData, this.state.solicitudid, this.props.equipoId)
    }
  
    handleClose = () => {
      if (this.state.aprobado.mensaje) {
        console.log(this.state.aprobado)
       
        this.setState({ open: false, selectedFileUrl: null, errors: {}, accion: null, aprobado: {}, imageUrl: null });
        this.props.getSolicitudesCorrectivos(this.props.equipoId);
      }
      else {
        this.setState({ open: false, selectedFileUrl: null, errors: {}, accion: null, imageUrl: null });
      }
    };
    
  
    


   render() {

    const { solicitudescorr, loadingsolcorr } = this.props.data;
    const { errors } = this.state;
    const { UI: { loading } } = this.props;

         const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 130,
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Tooltip title="Añadir Evidencia">
              <span>
                <IconButton
                  size="small"
                  disabled={params.row.estado === 'Atendida'}
                  onClick={() => this.handleOpen(params.row.solicitudid, params.row.imageUrl, 'agregar')}
                >
                  <AddAPhotoIcon sx={{ color: params.row.estado === 'Atendida' ? '#CCCCCC' : '#03178c' }} />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Ver evidencia cargada">
              <IconButton size="small" onClick={() => this.handleOpen(params.row.solicitudid, params.row.imageUrl, 'ver')}>
                <PhotoIcon sx={{ color: '#03178c' }} />
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
      { field: 'datecreation', headerName: 'Fecha', width: 120 },
      { field: 'nombresolicita', headerName: 'Solicitante', width: 150 },
      { field: 'fallareportada', headerName: 'Falla', width: 150 },
      { field: 'estado', headerName: 'Estado', width: 120 }
    ];

    const rows = Array.isArray(solicitudescorr)
      ? solicitudescorr
          .slice()
          .sort((a, b) => new Date(b.datecreation) - new Date(a.datecreation))
          .map((row, index) => ({ id: index, ...row }))
      : [];

    const mapeosolicitudescorrectivos = !loadingsolcorr ? (
      <Box sx={{ height: 500, width: '100%', mt: 2, '& .MuiDataGrid-columnHeaders': { backgroundColor: 'primary.main', color: 'white' } }}>
        <DataGrid
          rows={rows}
          columns={columns}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          disableRowSelectionOnClick
          components={{
            Toolbar: () => (
              <Box p={1}>
                <GridToolbarQuickFilter placeholder="Buscar..." />
              </Box>
            )
          }}
        />
      </Box>
    ) : (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
    return (
        <div className="listamtoprog-container">
              
        <div className="listamtoprog-table">
          <Typography sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600, textAlign: 'center', mb: 1 }}>
                          Solicitudes de Mantenimiento Correctivo
                        </Typography>
        {mapeosolicitudescorrectivos}
        </div>

        
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
        <DialogTitle>
          <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
            Cargar Evidencia fotográfica de la solicitud
          </Typography>
        </DialogTitle>

          <DialogContent>
            {
              this.state.accion == "agregar" ? (
                this.state.aprobado.mensaje ? (
                  <div className='div-aprobado'>
                    <div className='div-icono-aprobado'>
                      <FaCheck color="#ffffff" className='icono-aprobado' />
                    </div>
                    <h2 className='text-aprobado'>Evidencia cargada Exitosamente</h2>
                  </div>
                ) : (
                  <form>
             
                   <input type="file" onChange={this.onFileChange} accept="image/png,image/jpg" />
                      {this.state.selectedFileUrl?(<div className='div-image-carga'>
                      <img src={this.state.selectedFileUrl} alt="Selected" style={{ maxWidth: '100%', maxHeight: '400px' }} />
                      </div>):(<div></div>)}
                   
                  </form>)

              ) : (
                this.state.imageUrl ? (
                  <div>
                    <p> Esta es la evidencia cargada para esta solicitud </p>
                    <div className='div-image-carga'>

                      <img src={this.state.imageUrl} alt="Selected" style={{ maxWidth: '100%', maxHeight: '400px' }} />
                    </div>
                  </div>
                ) : (
                  <p>No hay evidencia cargada para mostrar</p>
                )
              )}
          </DialogContent>

          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose} size="small">
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>

            {loading ? <CircularProgress size={30} color="primary" className="login-progress" /> :
              this.state.accion == "agregar" ? (
                this.state.aprobado.mensaje ?
                  (
                    <></>
                  ) : (
                    <Tooltip title="Subir evidencia fotográfica">
                      <IconButton onClick={this.onFileUpload} size="small">
                        <FaPlus color="#03178C" />
                      </IconButton>
                    </Tooltip>
                  )
              ) : (
                <></>
              )

            }
          </DialogActions>
        </Dialog>



      </div>
    )
  }
}


HistorialSolicitudes.propTypes = {    
    getSolicitudesCorrectivos: PropTypes.func.isRequired,
    subirEvidenciaSolicitudCorrectivo:PropTypes.func.isRequired,
    data:PropTypes.object.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired,
    deleteMtoCorrectivo:PropTypes.func.isRequired
  };

const mapActionsToProps={subirEvidenciaSolicitudCorrectivo,getSolicitudesCorrectivos,clearErrors,deleteMtoCorrectivo};

const mapStateToProps = (state)=>({
    data:state.data,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(HistorialSolicitudes);

